import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * This component can be use in the router configuration to navigate
 * to a specific route and keeping the current language in the path
 * 
 * @example
 * {
 *   path: '',
 *   component : RedirectComponent,
 *   data : {
 *     to : environment.pages.start
 *   },
 *   pathMatch: 'full',
 * }
 * 
 */
@Component({
  selector: 'flow-redirect',
  template: '',
})
export class RedirectComponent {

  constructor(
    private router : Router,
    private route : ActivatedRoute,
  ) {
    this.route.data.subscribe((_data) => {
      var targetRoute = ['/', ..._data['to'].filter((str:string) => !!str)];
      this.router.navigate(targetRoute);
    });
  }
}
